import React from 'react';

import DataTable from '@components/DataTable';
import ProjectsPaywall from '@components/ProjectsPaywall';
import { useCurrentUser, useDatatableColumnConfig } from '@hooks';
import { DatabaseProps } from '@interfaces/projects';
import { project_path } from '@routes';

import BottomSection from './BottomSection';
import TopSection from './TopSection';

const Database = <TData, TValue>({
  data,
  paywallData,
  project,
  projectMedia,
  unlocked,
}: DatabaseProps<TData, TValue>): JSX.Element => {
  const { currentUser } = useCurrentUser();
  const projectImagePath = project_path(project.slug);
  const { columnConfigFn } = useDatatableColumnConfig(projectImagePath);

  const isCurrentUserCorpOrGroupSubscriber = currentUser?.is_corp_or_group_subscriber;
  const showBottomSection = isCurrentUserCorpOrGroupSubscriber || project.notes;

  return (
    <>
      <TopSection
        accessLevel={project.accessLevel}
        authors={project.authors}
        description={project.description}
        mediaSourcePath={projectImagePath}
        projectMedia={projectMedia}
        title={project.title}
        titleCallout={project.titleCallout}
      />
      {!unlocked ? (
        <>
          <div className="relative before:absolute before:bottom-0 before:left-0 before:z-10 before:h-[300px] before:w-full before:bg-[linear-gradient(to_top,#fff_0%,rgba(255,255,255,0)_100%)] before:content-['']"></div>
          <div className="sticky bottom-0 z-50">
            <ProjectsPaywall {...paywallData} leadType={project.leadType} />
          </div>
        </>
      ) : (
        <div className="w-container-lg mx-auto mt-32 max-w-container-lg px-16 sm:mt-48">
          <span id="no-paywall"></span>
          {/* MAIN TABLE COMPONENT */}
          {/* TODO: <TableKey /> https://app.asana.com/0/1207887684986161/1208027617035560/f */}
          <DataTable
            columns={data.columns}
            columnConfigFn={columnConfigFn}
            data={data.data}
            hiddenCols={data.hiddenCols}
            pinnedCols={data.pinnedCols}
            projectId={project.id}
            sortCols={data.sortCols}
            showSearch
          />
          {showBottomSection && (
            <BottomSection
              id={project.id}
              isCurrentUserCorpOrGroupSubscriber={isCurrentUserCorpOrGroupSubscriber}
              notes={project.notes}
              slug={project.slug}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Database;
